
/**
 * GENERIC_ERROR_MESSAGE
 * {string} The error message
 */
export const GENERIC_ERROR_MESSAGE = "There was an error, please try again";
